import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import {
  fetchAccountPlans,
  setActivePlanId,
  fetchAccountPlansActivation
} from 'alelo-logic/actions'

import { gqlQuery } from '../../../alelo-logic/services/common/apolloClient'
import { gqlParametrizacao } from '../../../alelo-logic/services/queries/parameterization'

import Header from '../../modules/Header'
import Submenu from '../../elements/Submenu'
import FooterSmall from '../../elements/FooterSmall'
import PageLoader from '../../modules/PageLoader'
import { subnavLinks } from './data.json'
import { RouteWithSubRoutes } from '../../../routes'
import veloeTagLinks from './linksVeloeTags.json'
import historicoVeloeTagLinks from './linksHistoricoTags.json'
import { setLoading } from '../../modules/PageLoader/actions'

class TemplateDashboard extends Component {
  async componentDidMount() {
    this.props.setLoading(true)
    if ((this.props.account || {}).wl || (this.props.account || {}).pc) {
      const typeAccountPartner = (this.props.account || {}).wl
        ? 'wl'
        : (this.props.account || {}).pc ? 'pc' : 'at'
      await this.props
        .fetchAccountPlansActivation(typeAccountPartner)
        .then(async () => {
          this.props.setActivePlanId(this.props.match.params.id)
          const infoChangeTags = await this.props.getInfoTags('avisoTrocaTags')
          await this.verifyChangeTags(infoChangeTags)
        })
        .then(() => this.props.setLoading(false))
    } else {
      await this.props
        .fetchAccountPlans()
        .then(async () => {
          this.props.setActivePlanId(this.props.match.params.id)
          const infoChangeTags = await this.props.getInfoTags('avisoTrocaTags')
          await this.verifyChangeTags(infoChangeTags)
        })
        .then(() => this.props.setLoading(false))
    }
  }

  async verifyChangeTags(list) {
    if (list) {
      const accountsId = await list.find(
        el => String(el.conta) === String(this.props.match.params.id)
      )

      if (accountsId) {
        sessionStorage.setItem('warnTags', JSON.stringify(accountsId))
      }
    }
  }

  async shouldComponentUpdate(nextProps) {
    this.props.setDataLayer(nextProps)
    const hasChange =
      // eslint-disable-next-line
      nextProps.accountPlans.activePlanId != nextProps.match.params.id ||
      nextProps.location.pathname !== this.props.location.pathname

    if (hasChange) {
      this.props.setActivePlanId(this.props.match.params.id)
      const infoChangeTags = await this.props.getInfoTags('avisoTrocaTags')
      await this.verifyChangeTags(infoChangeTags)
    }
    return hasChange
  }

  componentDidUpdate() {
    this.props.setActivePlanId(this.props.match.params.id)
  }

  render() {
    const { routes, accountPlans, match, location, account } = this.props
    const currentAccountPlan =
      (accountPlans && accountPlans.find(({ id }) => id === match.params.id)) || {} // eslint-disable-line
    const currentPlan = currentAccountPlan.plan || {}

    // Substitui no link o :id pelo id
    const subnavLinksWithPlanId =
      subnavLinks[currentPlan.type] &&
      subnavLinks[currentPlan.type].map(navLink => ({
        ...navLink,
        label: (this.props.account || {}).pc
          ? navLink.label.replace('Minhas VeloeTags', 'Consultar VeloeTags')
          : navLink.label,
        link: navLink.link.replace(':id', match.params.id)
      }))

    const veloeTagsLinksWithPlanId = veloeTagLinks.map(navLink => ({
      ...navLink,
      link: navLink.link.replace(':id', match.params.id)
    }))

    const hitoricoTagsLinkWithPlanId = historicoVeloeTagLinks.map(navLink => ({
      ...navLink,
      link: navLink.link.replace(':id', match.params.id)
    }))

    const showSubMenu =
      location.pathname.includes('/identificadores') || location.pathname.includes('/instalacao')

    return (
      <div>
        <div className="empty-template">
          <Header />
          <Submenu navItems={subnavLinksWithPlanId} />
        </div>
        {showSubMenu && (
          <Submenu
            secondary
            navItems={(account || {}).pc ? hitoricoTagsLinkWithPlanId : veloeTagsLinksWithPlanId}
          />
        )}
        <PageLoader>
          <div>{routes.map(route => <RouteWithSubRoutes key={route.path} {...route} />)}</div>
        </PageLoader>
        <div className="empty-template">
          <FooterSmall />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  account: state.reducer.account,
  accountPlans: state.reducer.accountPlans.plans
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchAccountPlansActivation: typeAccountPartner =>
    dispatch(fetchAccountPlansActivation()).then(accountPlans => {
      const { history, match } = ownProps

      if (accountPlans && (match.params.id === '' || match.params.id === 'resumo')) {
        const [_accountPlans = {}] = accountPlans || []
        let firstPlanId = accountPlans && _accountPlans && _accountPlans.id

        if (
          typeAccountPartner &&
          accountPlans.find(c => c.plan.category === 'TRANSAÇÕES WHITE LABEL')
        )
          firstPlanId = accountPlans.find(c => c.plan.category === 'TRANSAÇÕES WHITE LABEL').id

        history.push(`/minha-veloe/${firstPlanId}/resumo`)

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'login',
          eventCategory: 'veloe:login',
          eventAction: 'login:tentativa',
          eventLabel: 'sucesso',
          dimension1: _accountPlans.id,
          dimension4: _accountPlans.accountId
        })
      }
    }),
  fetchAccountPlans: () =>
    dispatch(fetchAccountPlans()).then(accountPlans => {
      const { history, match } = ownProps

      if (accountPlans && (match.params.id === '' || match.params.id === 'resumo')) {
        const [_accountPlans = {}] = accountPlans || []
        const firstPlanId = accountPlans && _accountPlans && _accountPlans.id
        history.push(`/minha-veloe/${firstPlanId}/resumo`)

        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'login',
          eventCategory: 'veloe:login',
          eventAction: 'login:tentativa',
          eventLabel: 'sucesso',
          dimension1: _accountPlans.id,
          dimension4: _accountPlans.accountId
        })
      }
    }),
  setActivePlanId: planId => dispatch(setActivePlanId(planId)),
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  },
  setDataLayer: ({ accountPlans = [], account }) => {
    window.dataLayer = window.dataLayer || []
    const [_accountPlans = {}] = accountPlans || []
    window.dataLayer.push({
      dimension1: _accountPlans.id,
      dimension4: _accountPlans.accountId,
      dimension6: 'logado',
      dimension7: account.accountType,
      diemsnion8: (_accountPlans.plan || {}).category
    })
  },
  getInfoTags: async parametro => {
    const { data: { parametrizacao } } = await gqlQuery(gqlParametrizacao, { parametro })
    const infoChangeTags = JSON.parse(parametrizacao[0].valor)
    return infoChangeTags
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TemplateDashboard))



// WEBPACK FOOTER //
// ./src/app/templates/TemplateDashboard/index.js